const MODULE_NAME = 'fulcrum/container/Project/FileUploadDialog/RESET_ACTIVE'
const RESET_ACTIVE = 'fulcrum/container/Project/FileUploadDialog/RESET_ACTIVE'
const UPDATE_INTERNAL = 'fulcrum/container/Project/FileUploadDialog/UPDATE_INTERNAL'
const RESET_INTERNAL = 'fulcrum/container/Project/FileUploadDialog/RESET_INTERNAL'
const UPDATE_ACTIVE = 'fulcrum/container/Project/FileUploadDialog/UPDATE_ACTIVE'
const UPDATE_PAGE = 'fulcrum/container/Project/FileUploadDialog/UPDATE_PAGE'
const RESET_PAGE = 'fulcrum/container/Project/FileUploadDialog/RESET_PAGE'
const UPDATE_FILE_TYPE = 'fulcrum/container/Project/FileUploadDialog/UPDATE_FILE_TYPE'
const RESET_FILE_TYPE = 'fulcrum/container/Project/FileUploadDialog/RESET_FILE_TYPE'
const CHANGE_PAGE = 'fulcrum/container/Project/FileUploadDialog/CHANGE_PAGE'
const CHANGE_ACTIVE = 'fulcrum/container/Project/FileUploadDialog/CHANGE_ACTIVE'
const DROP_REJECTED = 'fulcrum/container/Project/FileUploadDialog/DROP_REJECTED'

const POST_UPLOAD_FILE = 'fulcrum/container/Project/FileUploadDialog/POST_UPLOAD_FILE'
const POST_UPLOAD_FILE_START = 'fulcrum/container/Project/FileUploadDialog/POST_UPLOAD_FILE_START'
const POST_UPLOAD_FILE_SUCCESS = 'fulcrum/container/Project/FileUploadDialog/POST_UPLOAD_FILE_SUCCESS'
const POST_UPLOAD_FILE_ERROR = 'fulcrum/container/Project/FileUploadDialog/POST_UPLOAD_FILE_ERROR'

const FILE_ACCEPT_TYPE = [
  'application/zip',
  'image/jpeg',
  'image/png',
  'application/gzip',
  'application/pdf',
  'application/x-zip-compressed',
  'text/csv',
  'text/plain',
  'application/x-tar',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/x-7z-compressed',
  '.7z',
  '.tar',
  '.tgz',
  '.brd',
  '.log',
]

const FILE_TYPE_STRING = [
  '.jpg',
  '.jpeg',
  '.png',
  '.zip',
  '.pdf',
  '.csv',
  '.tar',
  '.ppt',
  '.pptx',
  '.xls',
  '.xlsx',
  '.xlsm',
  '.doc',
  '.docx',
  '.7z',
  '.tgz',
  '.brd',
  '.log',
]

const MAX_SIZE = 262144000//50mb

const FILE_TYPE = Object.freeze({
  SCHEMATIC: {
    value: 'SCHEMATIC',
    label: 'Schematic'
  },
  LAYOUT: {
    value: 'LAYOUT',
    label: 'Layout'
  },
  SOFTWARE_CHECKLIST: {
    value: 'SOFTWARE_CHECKLIST',
    label: 'Software Checklist'
  },
  PROJECT_WAIVER: {
    value: 'PROJECT_WAIVER',
    label: 'Project Waiver'
  },
  QUALIFICATION_VALIDATION_REPORT: {
    value: 'QUALIFICATION_VALIDATION_REPORT',
    label: 'Qualification/Validation Report'
  },
  SCHEMATIC_CHECKLIST: {
    value: 'SCHEMATIC_CHECKLIST',
    label: 'Schematic Checklist'
  },
  LAYOUT_CHECKLIST: {
    value: 'LAYOUT_CHECKLIST',
    label: 'Layout Checklist'
  },
  DESIGN_CHECKLIST_REPORT: {
    value: 'DESIGN_CHECKLIST_REPORT',
    label: 'Design Checklist Report'
  },
  NVQUAL_SYSTEM_TOPOLOGY: {
    value: 'NVQUAL_SYSTEM_TOPOLOGY',
    label: 'NVQual System Topology'
  },
  SYSTEM_IMAGES: {
    value: 'SYSTEM_IMAGES',
    label: 'System Images'
  },
  BLOCK_DIAGRAM: {
    value: 'BLOCK_DIAGRAM',
    label: 'Block Diagram'
  },
  FLOWRATE_QUALIFICATION_REPORT: {
    value: 'FLOWRATE_QUALIFICATION_REPORT',
    label: 'Flowrate Qualification Report'
  },
  PRESSURE_MEASUREMENT_REPORT: {
    value: 'PRESSURE_MEASUREMENT_REPORT',
    label: 'Pressure Measurement Report'
  },
  STRAIN_MEASUREMENT_REPORT: {
    value: 'STRAIN_MEASUREMENT_REPORT',
    label: 'Strain Measurement Report'
  },
  STRAIN_SIMULATION_REPORT: {
    value: 'STRAIN_SIMULATION_REPORT',
    label: 'Strain Simulation Report'
  },
  THERMAL_SIMULATION_REPORT: {
    value: 'THERMAL_SIMULATION_REPORT',
    label: 'Thermal Simulation Report'
  },
  THERMAL_VALIDATION_REPORT: {
    value: 'THERMAL_VALIDATION_REPORT',
    label: 'Thermal Validation Report'
  },
  MECHANICAL_DRAWING_REPORT: {
    value: 'MECHANICAL_DRAWING_REPORT',
    label: 'Mechanical Drawing Report'
  },
  SIMULATION_RESULT_REPORT: {
    value: 'SIMULATION_RESULT_REPORT',
    label: 'Simulation Result Report'
  },
  SYSTEM_TOPOLOGY_BLOCK_DIAGRAM: {
    value: 'SYSTEM_TOPOLOGY_BLOCK_DIAGRAM',
    label: 'System Topology Block Diagram'
  },
  VBIOS_REQUEST_FORM: {
    value: 'VBIOS_REQUEST_FORM',
    label: 'VBIOS Request Form'
  }, 
  SBIOS: {
    value: 'SBIOS',
    label: 'SBIOS'
  },
  OTHER: {
    value: 'OTHER',
    label: 'Other'
  },
})

const FILE_TYPE_NOTEBOOK = Object.freeze({
  SCHEMATIC: FILE_TYPE.SCHEMATIC,
  LAYOUT: FILE_TYPE.LAYOUT,
  SOFTWARE_CHECKLIST: FILE_TYPE.SOFTWARE_CHECKLIST,
  PROJECT_WAIVER: FILE_TYPE.PROJECT_WAIVER,
  QUALIFICATION_VALIDATION_REPORT: FILE_TYPE.QUALIFICATION_VALIDATION_REPORT,
  SCHEMATIC_CHECKLIST: FILE_TYPE.SCHEMATIC_CHECKLIST,
  LAYOUT_CHECKLIST: FILE_TYPE.LAYOUT_CHECKLIST,
  SBIOS: FILE_TYPE.SBIOS,
  VBIOS_REQUEST_FORM: FILE_TYPE.VBIOS_REQUEST_FORM,
  OTHER: FILE_TYPE.OTHER
})

const FILE_TYPE_DESKTOP = Object.freeze({
  SCHEMATIC: FILE_TYPE.SCHEMATIC,
  LAYOUT: FILE_TYPE.LAYOUT,
  PROJECT_WAIVER: FILE_TYPE.PROJECT_WAIVER,
  DESIGN_CHECKLIST_REPORT: FILE_TYPE.DESIGN_CHECKLIST_REPORT,
  QUALIFICATION_VALIDATION_REPORT: FILE_TYPE.QUALIFICATION_VALIDATION_REPORT,
  OTHER: FILE_TYPE.OTHER
})

const SEGMENT_FILE = {
  Notebook: FILE_TYPE_NOTEBOOK,
  Desktop: FILE_TYPE_DESKTOP,
  Enterprise: FILE_TYPE,
  Automotive: FILE_TYPE
}

const PAGE = Object.freeze({
  TYPE_SELECTION: 0,
  FILE_SELECTION: 1,
  UPLOADING: 2,
})

export {
  FILE_TYPE,
  SEGMENT_FILE,
  PAGE,
  MODULE_NAME,
  RESET_ACTIVE,
  UPDATE_ACTIVE,
  UPDATE_PAGE,
  RESET_PAGE,
  UPDATE_FILE_TYPE,
  UPDATE_INTERNAL,
  RESET_FILE_TYPE,
  RESET_INTERNAL,
  CHANGE_ACTIVE,
  CHANGE_PAGE,
  DROP_REJECTED,
  POST_UPLOAD_FILE,
  POST_UPLOAD_FILE_START,
  POST_UPLOAD_FILE_SUCCESS,
  POST_UPLOAD_FILE_ERROR,
  MAX_SIZE,
  FILE_ACCEPT_TYPE,
  FILE_TYPE_STRING
}
